import Button from '@app/components/presentational/base/button'
import PropTypes from 'prop-types'
import { Component, createRef } from 'react'
import CopyIcon from '../../../images/copy-icon.svg?component'

class CopyContainer extends Component {

  constructor(props) {
    super(props)

    this.targetTextInput = createRef()
  }

  /**
   * Render component
   */

  render() {
    return(
      <div>
        <Button
          className='copy-btn'
          onClick={ () => this.copy() }>
          <CopyIcon />
          {` ${I18n.t('javascript.actions.copy')}`}
          <input
            type='text'
            style={{ position: 'fixed', left: '-9999px', top: '-9999px' }}
            defaultValue={ this.props.target }
            ref={this.targetTextInput} />
        </Button>
        { this.props.showTarget &&
          <span className={this.props.targetClassName}>{this.props.target}</span> }
      </div>
    )
  }

  /**
   * Private methods
   */

  copy() {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(this.props.target)
    } else {
      this.copyToClipboard()
    }
  }

  copyToClipboard() {
    this.targetTextInput.current.select()

    document.execCommand('copy')
  }
}

CopyContainer.propTypes = {
  target: PropTypes.string.isRequired,
  targetClassName: PropTypes.string,
  showTarget: PropTypes.bool
}

CopyContainer.defaultProps = {
  showTarget: true
}

export default CopyContainer
